// extracted by mini-css-extract-plugin
module.exports = {"comp":"ModuleC_comp__yu51z"};